<!--
 * @Author: 曹捷
 * @Date: 2019-08-19 15:24:34
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-02-11 13:11:53
 * @Description: file content
 -->
<template>
  <a-modal class="obit-modal-default useradd" :confirm-loading="confirmLoading" :maskClosable="false" :title="showTitle" v-model:visible="open" @cancel="closeDialog" @ok="saveInfo" cancelText="取消"
    okText="确认" width="1080px">
    <a-form :inline="true" :model="formData" :rules="rules" ref="formRef" :label-col="{span: 6}" :wrapper-col="{span:18}">
      <div class="drawing-board">
        <a-row :gutter="24">
          <a-col :span="24">
            <p class="title bold">基础信息</p>
          </a-col>
          <a-col :span="12">
            <a-form-item label="登录账号" name="userName">
              <a-input :maxlength="20" placeholder="设置用户登录账号" show-word-limit v-model:value="formData.userName" :disabled="addType === 'edit'"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="addType === 'add'">
            <a-form-item label="登录密码" name="password">
              <a-input-password :maxlength="20" placeholder="设置登录密码" v-model:value="formData.password">
              </a-input-password>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="用户姓名" name="nickName">
              <a-input :maxlength="20" placeholder="输入用户姓名" show-word-limit v-model:value="formData.nickName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="addType === 'add'">
            <a-form-item label="再次输入密码" name="againpassword">
              <a-input-password :maxlength="20" placeholder="输入密码" v-model:value="formData.againpassword">
              </a-input-password>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <p class="title bold">详情信息</p>
          </a-col>
          <a-col :span="12">
            <a-form-item label="手机号码" name="phonenumber">
              <a-input :maxlength="11" placeholder="输入手机号码" show-word-limit v-model:value="formData.phonenumber">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="邮箱" name="email">
              <a-input :maxlength="32" placeholder="输入邮箱" show-word-limit v-model:value="formData.email"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="性别" name="sex">
              <obit-dict dictCode="sys_user_sex" placeholder="选择性别" v-model:value="formData.sex"></obit-dict>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="生日" name="birthday">
              <a-date-picker size="large" v-model:value="formData.birthday" show-word-limit placeholder="选择生日" :disabledDate="disabledDate" :valueFormat="format"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <p class="title bold">职责信息</p>
          </a-col>
          <a-col :span="12">
            <a-form-item label="部门" name="deptId">
              <obit-cascader :valueName="pData.id" :label="pData.label" :children="pData.children" :parentId="pData.parentId" :options="orgList" v-model:value="formData.deptId" :changeOnSelect="true"
                placeholder="选择部门">
              </obit-cascader>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="角色" name="roleIds">
              <a-select mode="multiple" v-model:value="formData.roleIds" placeholder="请选择角色">
                <a-select-option v-for="item in roleSelectList" :key="item.roleId">
                  {{item.roleName}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
           <a-col :span="12">
            <a-form-item label="用户类型" name="staffType">
              <obit-dict dictCode="sys_staff_type" placeholder="用户类型" v-model:value="formData.staffType"></obit-dict>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="岗位" name="postName">
              <obit-dict dictCode="sys_user_post" placeholder="岗位" v-model:value="formData.postName"></obit-dict>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="编号" name="userNo">
              <a-input v-model:value="formData.userNo" :maxLength="25" show-word-limit placeholder="输入编号">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="工号" name="jobNo">
              <a-input v-model:value="formData. jobNo" :maxLength="50" show-word-limit placeholder="输入工号">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="地址" name="userAddress">
              <a-input :maxlength="100" placeholder="请点击右侧小图标，选择详细地址" readonly show-word-limit v-model:value="formData.userAddress">
                <template #suffix>
                  <i title="点击选择地址" class="iconfont icon-location pointer" @click="mapVisable =  true"></i>
                </template>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" name="remark">
              <a-textarea v-model:value="formData.remark" :maxLength="2000" show-word-limit placeholder="输入备注">
              </a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <p class="title bold">所属区域</p>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="`区域${index+1}`" v-for="(item,index) in formData.areaId" :key="item.key">
              <div class="flex-l-r">
                <obitCascaderUrl valueName="id" label="shortName" parentId="parentId" children="children" :changeOnSelect="true" loadData="area" url="system/area/selectByParentId"
                  v-model:value="item.id" placeholder="请选择区域" :mounted="addType==='add'?null:initCascader">
                </obitCascaderUrl>
                <div class="area-menu flex-c">
                  <i title="删除" @click="formData.areaId.splice(index,1)" class="iconfont icon-minus-circle pointer  " v-if="index>0"></i>
                  <i title="新增区域" v-if="index ===0" @click="addArea" class="iconfont icon-add-circle pointer"></i>
                </div>
              </div>
            </a-form-item>
          </a-col>

        </a-row>
      </div>
    </a-form>
    <obitMapSearch v-model:open="mapVisable" v-if="mapVisable" @success="mapSuccess"></obitMapSearch>
  </a-modal>
</template>
<script>
import { computed, inject, reactive, toRefs, onMounted } from 'vue'
import { util } from 'obit-wui'
import { obitMapSearch } from 'obit-wui/components/obit-map'
import dayjs from "dayjs";

// import obitSelectTags from './obit-select-tags.vue'
export default {
  components: { obitMapSearch },
  emits: ['reload'],
  props: {
    open: {
      type: Boolean
    },
    addType: {
      type: String,
    },
    detailsInfo: {
      type: Object,
    },
  },
  setup (props, context) {
    let http = inject('http')
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('设置登录密码'));
      } else {
        if (value.length < 6) {
          callback(new Error('密码长度不能低于6位'));
        } else {
          callback();
        }
      }
    }
    let checkAgainPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('输入密码'));
      } else {
        if (value !== _data.formData.password) {
          callback(new Error('两次输入密码不一致'));
        } else {
          if (value.length < 6) {
            callback(new Error('密码长度不能低于6位'));
          } else {
            callback();
          }
        }
      }
    }
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('输入手机号码'));
      } else {
        let rules = /^1[345789]\d{9}$/
        if (rules.test(value)) {
          callback();
        } else {
          callback(new Error('输入11位手机号'));
        }
      }
    }
    let _data = reactive({
      formData: {
        areaId: [{ key: util.util.UUID(), id: '' }]
      },
      orgList: {},
      formRef: null,
      roleSelectList: [],
      format: 'YYYY-MM-DD',
      confirmLoading: false,
      postName: ['董事长'],
      mapVisable: false,
      options: [
        {
          value: '董事长',
          label: '董事长',
        },
        {
          value: '总经理',
          label: '总经理',
        },
        {
          value: '部门主管',
          label: '部门主管',
        },
      ],
      pData: { label: 'label', id: 'id', children: 'children', parentId: 'parentId' },
      rules: {
        userName: [
          { required: true, message: '设置用户登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: checkPassword, trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '输入用户姓名', trigger: 'blur' }
        ],
        againpassword: [
          { required: true, validator: checkAgainPassword, trigger: 'blur' }
        ],
        phonenumber: [
          { required: true, validator: checkMobile, trigger: 'blur' }
        ],
        roleIds: [
          { required: true, message: '选择用户角色', trigger: 'blur', type: 'array' }
        ],
        sex: [
          { required: true, message: '选择性别', trigger: 'blur' },
        ],
        deptId: [
          { required: true, message: '选择部门', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '输入邮箱', trigger: 'blur' },
        ],
        staffType: [
          { required: true, message: '选择用户类型', trigger: 'blur' },
        ],
      },
    })
    let _computed = {
      showTitle: computed(() => props.addType === 'add' ? '新增' : '修改')
    }
    let _methods = {
      /**
       * 区域回显
       */
      async initCascader (info) {
        let list = await http.commonPost('system/area/getTreeById', { id: info.value })
        return list
      },
      addArea () {
        _data.formData.areaId.push({ key: util.util.UUID(), id: '' })
      },
      getPostRole (url) {
        http.sysPost(url).then(res => {
          let dataInfo = res.data
          if (dataInfo && dataInfo.areaId) {
            let list = []
            dataInfo.areaId.split(',').forEach(element => {
              list.push({ id: element, key: util.util.UUID() })
            });
            _data.formData.areaId = list
          } else {
            _data.formData.areaId = [{ key: util.util.UUID(), id: '' }]
          }
          _data.roleSelectList = res.roles
          _data.formData.roleIds = []
          _data.formData.roleIds = _methods.toStringArray(res.roleIds)
        })
      },
      toStringArray (arr) {
        if (!arr) {
          return []
        } else {
          let list = []
          arr.forEach(item => {
            list.push(item.toString())
          })
          return list
        }
      },
      saveInfo () {
        _data.formRef.validate().then(() => {
          _data.confirmLoading = true
          let param = util.util.cloneObj(_data.formData)
          param.areaId = param.areaId.reduce((list, item) => list.concat([item.id]), []).join(',')
          delete param.againpassword
          http.saveSystemUserInfo(param, props.addType).then((res) => {
            context.emit('reload', props.addType === 'add')
            _data.confirmLoading = false
            _methods.closeDialog()
          }).catch(() => {
            _data.confirmLoading = false
          })
        })
      },
      closeDialog () {
        util.util.cleanObj(_data.formData)
        context.emit('update:open', false)
      },
      mapSuccess (info) {
        _data.formData.userAddress = info.address
      },
      disabledDate (current) {
        return current && current > dayjs();
      },
    }
    onMounted(() => {
      _data.orgList = []
      if (props.addType === 'edit') {
        let dataInfo = util.util.cloneObj(props.detailsInfo)

        _data.formData = dataInfo
        _methods.getPostRole(`system/user/detail/${props.detailsInfo.userId}`)
      } else {
        _methods.getPostRole('system/user/detail')
      }
      http.sysGetTreeSelect().then(data => {
        _data.orgList = util.util.cloneObj(data)
      })
    })
    return {
      ..._computed,
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>
<style lang="less">
.useradd {
  .ant-form-item-control-input-content {
    width: 100%;
    .ant-calendar-picker {
      width: 100%;
    }
  }
  .area-menu {
    width: 80px;
    text-align: center;
  }
}
</style>